import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 53"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "2"
    }, [
      _createElementVNode("path", { d: "M16.365 13.556C17.315 11.852 17.79 11 18.5 11s1.185.852 2.135 2.556l.246.441c.27.484.405.727.615.886s.473.22.997.338l.477.108c1.845.417 2.768.626 2.987 1.332s-.41 1.44-1.667 2.911l-.325.381c-.358.418-.536.627-.617.885-.08.259-.053.538 0 1.095l.05.508c.19 1.962.285 2.943-.29 3.38-.574.435-1.437.038-3.165-.757l-.446-.206c-.491-.226-.737-.34-.997-.34s-.505.114-.996.34l-.447.206c-1.727.795-2.591 1.192-3.166.756s-.48-1.417-.289-3.38l.05-.507c.053-.557.08-.836 0-1.095-.08-.258-.26-.467-.617-.885l-.325-.38c-1.258-1.471-1.886-2.206-1.667-2.912.22-.706 1.142-.915 2.987-1.332l.477-.108c.524-.119.786-.178.997-.338s.345-.402.615-.886z" }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "m6.878 33.5-1.592 5.808c-1.571 5.73-2.357 8.594-1.309 10.162.368.55.86.991 1.432 1.282 1.632.83 4.151-.482 9.19-3.107 1.676-.873 2.514-1.31 3.405-1.405q.496-.052.992 0c.891.095 1.73.532 3.406 1.405 5.038 2.625 7.557 3.938 9.189 3.107a3.8 3.8 0 0 0 1.431-1.282c1.049-1.568.263-4.433-1.308-10.162L30.122 33.5"
      }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M2.25 11.992A17.5 17.5 0 0 0 1 18.5C1 28.165 8.835 36 18.5 36S36 28.165 36 18.5 28.165 1 18.5 1c-2.3 0-4.496.444-6.508 1.25"
      })
    ], -1)
  ]))]))
}
export default { render: render }